import { DatePipe, TitleCasePipe } from '@angular/common';
import { Component, effect, inject, input } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Shipment } from '../../shared/models/shipment';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-shipments-table',
  imports: [
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    TitleCasePipe
  ],
  templateUrl: './shipments-table.component.html',
  styleUrl: './shipments-table.component.scss',
  providers: [DatePipe, TitleCasePipe]
})
export class ShipmentsTableComponent {
  shipments = input.required<Shipment[]>();
  columns = input<(keyof Shipment)[]>([
    'AssignedTimestamp',
    'Courier',
    'ShipmentId',
    'SalesPersonId',
    'SalesPersonName',
    'CompanyName',
    'PoNumber',
    'CreditNumber',
    'Status'
  ]);
  dataSource: MatTableDataSource<Shipment> = new MatTableDataSource();

  private readonly datePipe = inject(DatePipe);

  constructor() {
    effect(() => {
      this.dataSource.data = this.shipments().map(shipment => {
        let trackingUrl = '';
        switch (shipment.Courier.toLowerCase()) {
          case 'postnord':
            trackingUrl = `${environment.couriers.postnord.trackingUrl}?id=${shipment.ShipmentId}`;
            break;
          case 'dhl':
            trackingUrl = `${environment.couriers.dhl.trackingUrl}?submit=1&tracking-id=${shipment.ShipmentId}`;
            break;
        }
        return { ...shipment, trackingUrl };
      });
    });
  }

  formatDate(utcDate: string): string {
    const localDate = new Date(utcDate);
    return this.datePipe.transform(localDate, 'yyyy-MM-dd HH:mm') || '';
  }

  formatStatus(status: string): string {
    if (status == "USED") return "Inlämnad";
    if (status == "RECEIVED") return "På väg";
    if (status == "DELIVERED") return "Levererad";
    return "Okänd";
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    let modifiedFilterValue;

    if (filterValue.startsWith(']C1')) {
      modifiedFilterValue = filterValue.slice(3);
    } else {
      modifiedFilterValue = filterValue;
    }
    this.dataSource.filter = modifiedFilterValue.trim().toLowerCase();
  }
}
